module.exports = __webpack_public_path__ + "img/seller-b2.9552a00f.png";